import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Moment from 'moment';
import { extendMoment } from 'moment-range';

import { getFormValues } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import dateFormat from 'config/dateFormat';

import { fetchOrdersStatistics } from 'redux/modules/ordersStatistics';
import throttle from 'utils/throttle';

import * as validate from 'utils/validate';

import pxToRem from 'styles/pxToRem';

import StatsLineChartForm from './StatsLineChartForm';
import StatsLineChartChart from './StatsLineChartChart';

const moment = extendMoment(Moment);

const styles = theme => ({
  root: {
    marginTop: 16,
    position: 'relative',
    minHeight: 368,
    marginBottom: 16,
    maxHeight: '100%',
    boxSizing: 'border-box',
    padding: 0,
    overflow: 'visible',
    [theme.breakpoints.down('sm')]: {
      padding: 8,
    },
  },
});

class StatsLineChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: moment().subtract(6, 'days').format(dateFormat),
      dateTo: moment().format(dateFormat),
      'Workflow State ID': null,
      'Workflow State Name': null,
      'Workflow Status ID': null,
      'Workflow Status Name': null,
    };

    this.onRequest = this.onRequest.bind(this);

    this.onRequest = throttle(this.onRequest);
  }

  componentDidMount() {
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    const { ordersStatisticsFormValues } = this.props;
    const newState = {};
    if (nextProps.ordersStatisticsFormValues['Workflow State ID'] !== ordersStatisticsFormValues['Workflow State ID']) {
      if (nextProps.ordersStatisticsFormValues['Workflow State ID']) {
        newState['Workflow State ID'] = nextProps.ordersStatisticsFormValues['Workflow State ID'];
        newState['Workflow State Name'] = nextProps.ordersStatisticsFormValues.State;
      } else {
        newState['Workflow State ID'] = null;
        newState['Workflow State Name'] = null;
      }
    }
    if (nextProps.ordersStatisticsFormValues['Workflow Status ID'] !== ordersStatisticsFormValues['Workflow Status ID']) {
      if (nextProps.ordersStatisticsFormValues['Workflow Status ID']) {
        newState['Workflow Status ID'] = nextProps.ordersStatisticsFormValues['Workflow Status ID'];
        newState['Workflow Status Name'] = nextProps.ordersStatisticsFormValues.Status;
      } else {
        newState['Workflow Status ID'] = null;
        newState['Workflow Status Name'] = null;
      }
    }
    if (nextProps.ordersStatisticsFormValues['Date Range']) {
      if (nextProps.ordersStatisticsFormValues['Date Range'] !== ordersStatisticsFormValues['Date Range']) {
        newState.dateTo = moment().format(dateFormat);
        let dateFrom;
        switch (nextProps.ordersStatisticsFormValues['Date Range']) {
          case '1y':
            dateFrom = moment().subtract(1, 'year').add(1, 'day').format(dateFormat);
            break;
          case '1m':
            dateFrom = moment().subtract(1, 'month').add(1, 'day').format(dateFormat);
            break;
          case '1w':
            dateFrom = moment().subtract(1, 'week').add(1, 'day').format(dateFormat);
            break;
          default:
            dateFrom = moment().subtract(1, 'week').format(dateFormat);
        }
        newState.dateFrom = dateFrom;
      }
    } else if (nextProps.ordersStatisticsFormValues['Date From']
      && nextProps.ordersStatisticsFormValues['Date To']
      && !validate.date(nextProps.ordersStatisticsFormValues['Date From'])
      && !validate.date(nextProps.ordersStatisticsFormValues['Date To'])
      && !moment(nextProps.ordersStatisticsFormValues['Date To'], dateFormat)
        .isBefore(moment(nextProps.ordersStatisticsFormValues['Date From'], dateFormat))
      && (nextProps.ordersStatisticsFormValues['Date From'] !== ordersStatisticsFormValues['Date From']
      || nextProps.ordersStatisticsFormValues['Date To'] !== ordersStatisticsFormValues['Date To']
      || nextProps.ordersStatisticsFormValues['Date Range'] !== ordersStatisticsFormValues['Date Range'])) {
      newState.dateFrom = moment(nextProps.ordersStatisticsFormValues['Date From'], dateFormat).format(dateFormat);
      newState.dateTo = moment(nextProps.ordersStatisticsFormValues['Date To'], dateFormat).format(dateFormat);
    }

    this.setState(newState);
  }

  componentDidUpdate(prevProps, prevState) {
    const { dateFrom, dateTo } = this.state;
    if (prevState.dateFrom !== dateFrom
      || prevState.dateTo !== dateTo
      || prevState['Workflow State ID'] !== this.state['Workflow State ID']
      || prevState['Workflow Status ID'] !== this.state['Workflow Status ID']) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions } = this.props;
    const { dateFrom, dateTo } = this.state;
    actions.fetchOrdersStatistics({
      triggerLoading: true,
      'Date From': dateFrom,
      'Date To': dateTo,
      ...this.state['Workflow State ID'] ? { 'Workflow State ID': this.state['Workflow State ID'] } : {},
      ...this.state['Workflow Status ID'] ? { 'Workflow Status ID': this.state['Workflow Status ID'] } : {},
    });
  }

  render() {
    const {
      ordersStatistics,
      ordersStatisticsFormValues,
      loading,
      classes,
    } = this.props;
    const { dateFrom, dateTo } = this.state;
    const momentDateRange = moment.range(moment(dateFrom, dateFormat),
      moment(dateTo, dateFormat));
    let dateStep;
    let tickStep;
    if (momentDateRange > moment.range(moment(), moment().add(365, 'days'))) {
      dateStep = 'month';
      if (momentDateRange > moment.range(moment(), moment().add(500, 'days'))) {
        tickStep = '2 months';
      } else {
        tickStep = 'month';
      }
    } else if (momentDateRange > moment.range(moment(), moment().add(70, 'days'))) {
      dateStep = 'week';
      if (momentDateRange > moment.range(moment(), moment().add(150, 'days'))) {
        tickStep = 'month';
      } else if (momentDateRange > moment.range(moment(), moment().add(80, 'days'))) {
        tickStep = '2 weeks';
      } else {
        tickStep = 'week';
      }
    } else {
      dateStep = 'day';
      if (momentDateRange > moment.range(moment(), moment().add(8, 'days'))) {
        tickStep = 'week';
      } else {
        tickStep = 'day';
      }
    }
    const dates = Array.from(momentDateRange.by(dateStep));
    const statistics = dates.map((dateMoment) => {
      const date = dateMoment.format(dateFormat);
      const ordersStatisticsItem = dateStep === 'day'
        ? ordersStatistics.find(item => item.date === date)
        : ordersStatistics.find(item => item.date[0] === date);
      if (ordersStatisticsItem) {
        return {
          ...ordersStatisticsItem,
          date,
          dateTo: dateStep === 'day' || !Array.isArray(ordersStatisticsItem.date)
            ? date
            : ordersStatisticsItem.date[ordersStatisticsItem.date.length - 1],
        };
      }
      return {
        date,
        dateTo: date,
        patients: 0,
        total_charges: '0',
        order_line_counts: 0,
      };
    });

    const dateRangeMin = !ordersStatisticsFormValues['Date To']
      && ordersStatisticsFormValues['Date From']
      && moment(ordersStatisticsFormValues['Date From'], dateFormat, true).isValid()
      ? moment(ordersStatisticsFormValues['Date From'], dateFormat).format(dateFormat)
      : null;
    let dateRangeMax = !ordersStatisticsFormValues['Date To']
      && ordersStatisticsFormValues['Date From']
      && moment(ordersStatisticsFormValues['Date From'], dateFormat, true).isValid()
      ? moment(ordersStatisticsFormValues['Date From'], dateFormat)
        .add(2, 'years').format(dateFormat)
      : null;
    if (moment(dateRangeMax, dateFormat).isAfter(moment())) {
      dateRangeMax = moment().format(dateFormat);
    }
    return (
      <Paper className={classes.root}>
        <StatsLineChartForm
          dateRangeMin={dateRangeMin}
          dateRangeMax={dateRangeMax}
          form="ordersStatisticsForm"
          initialValues={{ 'Date Range': '1w' }}
        />
        <StatsLineChartChart
          statistics={statistics}
          tickStep={tickStep}
          dateStep={dateStep}
          loading={loading}
          workflowStateId={this.state['Workflow State ID']}
          workflowStatusId={this.state['Workflow Status ID']}
          workflowStateName={this.state['Workflow State Name']}
          workflowStatusName={this.state['Workflow Status Name']}
        />
      </Paper>
    );
  }
}

StatsLineChart.propTypes = {
  ordersStatistics: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
    patients: PropTypes.number.isRequired,
    total_charges: PropTypes.string.isRequired,
    order_line_counts: PropTypes.number.isRequired,
  })).isRequired,
  ordersStatisticsFormValues: PropTypes.shape({
    'Date Range': PropTypes.string,
    'Date From': PropTypes.string,
    'Date To': PropTypes.string,
    State: PropTypes.string,
    Status: PropTypes.string,
  }),
  loading: PropTypes.number.isRequired,
  actions: PropTypes.shape({
    fetchOrdersStatistics: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

StatsLineChart.defaultProps = {
  ordersStatisticsFormValues: {},
};

const mapStateToProps = (store) => {
  const ordersStatisticsFormValues = getFormValues('ordersStatisticsForm')(store);
  return {
    ordersStatisticsFormValues: ordersStatisticsFormValues || { 'Date Range': '1w' },
    ordersStatistics: store.ordersStatistics.data,
    loading: store.ordersStatistics.loading,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchOrdersStatistics }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(StatsLineChart),
);



// WEBPACK FOOTER //
// ./src/components/home/StatsLineChart/StatsLineChart.js